// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"cb1b0590","422":"0d51bfb8","689":"83e11e6e","884":"0d51bfb8"}[chunkId] + ".chunk.css";
};